module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowLight.d350b63.eot";